module.exports = __webpack_public_path__ + "public/images/travel.abf61789cdb6008cae7f7285686182f7.png";